/**
 * formatEquineAge(dateOfBirth)
 *
 * Convention FEI (fédération équestre internationale) :
 * tout cheval prend un an au 1er janvier, indépendamment de sa date
 * de naissance réelle. Calcul = différence des années calendaires.
 *
 * Cas <1 an (né dans l'année en cours) : affichage en mois.
 *
 * @param {Date|string|null} dateOfBirth
 * @returns {string|null} "3 mois" / "1 an" / "5 ans" / null si pas de date
 */
export function formatEquineAge(dateOfBirth) {
  if (!dateOfBirth) return null;
  const birth = new Date(dateOfBirth);
  if (isNaN(birth.getTime())) return null;
  const now = new Date();
  // Date future → considérée invalide, retourne null (pas de crash)
  if (birth > now) return null;

  const yearDiff = now.getFullYear() - birth.getFullYear();

  if (yearDiff === 0) {
    // Né cette année → afficher en mois
    const months = (now.getMonth() - birth.getMonth())
                 + (now.getDate() < birth.getDate() ? -1 : 0);
    const safeMonths = Math.max(0, months);
    if (safeMonths === 0) return 'moins d\'1 mois';
    return `${safeMonths} mois`;
  }

  return `${yearDiff} an${yearDiff > 1 ? 's' : ''}`;
}
